module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-grid-list', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs12": "",
      "sm4": "",
      "lg2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tags,
      "item-text": "name",
      "item-value": "id",
      "label": "Select Tags",
      "small-chips": "",
      "max-height": "400",
      "content-class": "select-tags",
      "single-line": "",
      "append-icon": "local_offer",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (data.index < 1),
            expression: "data.index < 1"
          }],
          staticClass: "chip--select-multi"
        }, [_vm._v("\n                        " + _vm._s(data.item.name) + "\n                    ")]), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": "",
            "max-width": "200"
          }
        }, [(data.index === 1) ? _c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("(+" + _vm._s(data.parent.selectedItems.length - 1) + ")")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.parent.selectedItems.filter(function (v) { return v.name !== data.item.name; }).map(function (v) { return v.name; }).join(", ")))])])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-action', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "input-value": data.parent.selectedItems.includes(data.item)
          }
        })], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                        " + _vm._s(data.item.name) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-action', {
          staticClass: "hidden",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.form.tagIds = [data.item.id]
            }
          }
        }, [_c('v-btn', {
          staticClass: "min-width-0",
          attrs: {
            "small": ""
          }
        }, [_vm._v("ONLY")])], 1)]
      }
    }]),
    model: {
      value: (_vm.form.tagIds),
      callback: function($$v) {
        _vm.$set(_vm.form, "tagIds", $$v)
      },
      expression: "form.tagIds"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs6": "",
      "sm4": "",
      "lg2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.times,
      "max-height": "400",
      "offset-y": ""
    },
    model: {
      value: (_vm.form.time),
      callback: function($$v) {
        _vm.$set(_vm.form, "time", $$v)
      },
      expression: "form.time"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "xs6": "",
      "sm4": "",
      "lg2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sort By",
      "items": _vm.sorts,
      "max-height": "400",
      "offset-y": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28730695","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageBrowseTracksFilters.vue
// module id = 352
// module chunks = 0